import { createFileRoute } from "@tanstack/react-router";
import { AutomationsNewPage } from "@/components/automations/automations-new-page";
import { OwnerWorkspaceGate } from "@/components/owner-workspace-gate";
import { parsePrefilledChannel } from "@/lib/automations/prefilled-channel";
import { useWorkspaceRoot } from "@/lib/api";

/**
 * Workspace-level Automation create — the single authoring entry point for
 * automations. Search params prefill a first trigger (Slack channel notices,
 * agent-thread suggestions) and optionally the agent executor.
 */
export const Route = createFileRoute("/$owner/automations/new")({
	loader: ({ context: { queryClient }, params }) => {
		void queryClient.prefetchQuery(
			useWorkspaceRoot.queryOptions(params.owner, { slug: params.owner }),
		);
	},
	validateSearch: (search: Record<string, unknown>) =>
		parsePrefilledChannel(search),
	component: WorkspaceAutomationsNewPage,
});

function WorkspaceAutomationsNewPage() {
	const { owner } = Route.useParams();
	const prefilled = Route.useSearch();
	return (
		<OwnerWorkspaceGate owner={owner}>
			{() => <AutomationsNewPage owner={owner} prefilled={prefilled} />}
		</OwnerWorkspaceGate>
	);
}
